/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Stage_Lost_ShortInputs */

const cs_pipelines_stage_lost_short = /** @type {(inputs: Pipelines_Stage_Lost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohra`)
};

const en_pipelines_stage_lost_short = /** @type {(inputs: Pipelines_Stage_Lost_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost`)
};

/**
* | output |
* | --- |
* | "Lost" |
*
* @param {Pipelines_Stage_Lost_ShortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_lost_short = /** @type {((inputs?: Pipelines_Stage_Lost_ShortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_Lost_ShortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_lost_short(inputs)
	return cs_pipelines_stage_lost_short(inputs)
});